module.exports = __webpack_public_path__ + "static/media/chatwindow.3b376614.svg";